import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import EditorCanvasSli from "../../canvas/editor_canvas_sli/EditorCanvasSli";
import EditorCanvasDoc from "../../canvas/editor_canvas_doc/EditorCanvasDoc";
import { isSlide } from "../../../../common/utils";

/**
 * ContainerJS component to render contained views
 *
 */
export default class ContainedCanvas extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);
    /**
     * Component's initial state
     * @type {{showTitle: boolean}}
     */
    this.state = {
      showTitle: false,
    };
  }

  /**
   * Render React Component
   * @returns {*}
   */
  render() {
    let canvasContent;
    let containedViewSelected = this.props.containedViewSelected;
    if (containedViewSelected && containedViewSelected !== 0) {
      if (isSlide(containedViewSelected.type)) {
        canvasContent = <EditorCanvasSli fromCV {...this.props} />;
      } else {
        canvasContent = <EditorCanvasDoc fromCV {...this.props} />;
      }
    } else {
      canvasContent = (
        <Col
          id="containedCanvas"
          md={12}
          xs={12}
          style={{
            height: "100%",
            padding: 0,
            display: this.props.containedViewSelected !== 0 ? "initial" : "none",
          }}
        />
      );
    }
    return canvasContent;
  }

  /**
   * Before component receives props
   * @param nextProps
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.boxSelected !== -1) {
      this.setState({ showTitle: false });
    }
  }
}

ContainedCanvas.propTypes = {
  /**
   * Relación de aspecto para diapositivas
   */
  canvasRatio: PropTypes.number.isRequired,
  /**
   * Indicador de si se muestra el canvas (tiene qu haber un navItem seleccionado)
   */
  showCanvas: PropTypes.bool,
  /**
   * Object containing all created boxes (by id)
   */
  boxes: PropTypes.object.isRequired,
  /**
   * Caja seleccionada en el momento. Si no hay ninguna, -1
   */
  boxSelected: PropTypes.any.isRequired,
  /**
   * Nivel de profundidad de caja seleccionada (sólo para plugins dentro de plugins)
   */
  boxLevelSelected: PropTypes.number.isRequired,
  /**
   * Object containing all views (by id)
   */
  navItems: PropTypes.object.isRequired,
  /** *
   * Current selected view (by ID)
   */
  navItemSelected: PropTypes.any.isRequired,
  /**
   * Object containing all contained views (identified by its ID)
   */
  containedViews: PropTypes.object.isRequired,
  /** *
   * Selected contained view
   */
  containedViewSelected: PropTypes.any.isRequired,
  /**
   * Título del curso
   */
  title: PropTypes.string.isRequired,
  /**
   * Diccionario que contiene todas las istas creadas , accesibles por su *id*
   */
  viewToolbars: PropTypes.object.isRequired,
  /**
   * Diccionario que contiene todos los valores de cajas, accesibles por su *id*
   */
  pluginToolbars: PropTypes.object.isRequired,
  /**
   * Última acción realizada en Redux
   */
  lastActionDispatched: PropTypes.any.isRequired,
  /** *
   * Añade una marca a la caja
   */
  addMarkShortcut: PropTypes.func.isRequired,
  /**
   * Función que oculta el overlay de creación de marcas
   */
  deleteMarkCreator: PropTypes.func.isRequired,
  /**
   * Identificador de la caja en la que se va a crear una marca
   */
  markCreatorId: PropTypes.any.isRequired,
  /**
   * Oculta/muestra el overlay de creación de marcas
   */
  onMarkCreatorToggled: PropTypes.func.isRequired,
  /**
   * Callback for adding a box
   */
  onBoxAdded: PropTypes.func.isRequired,
  /**
   * Borra una caja
   */
  onBoxDeleted: PropTypes.func.isRequired,
  /**
   * Selecciona la caja
   */
  onBoxSelected: PropTypes.func.isRequired,
  /**
   * Aumenta el nivel de profundidad de selección (plugins dentro de plugins)
   */
  onBoxLevelIncreased: PropTypes.func.isRequired,
  /**
   * Mueve la caja
   */
  onBoxMoved: PropTypes.func.isRequired,
  /**
   * Redimensiona la caja
   */
  onBoxResized: PropTypes.func.isRequired,
  /**
   * Suelta la caja en una zona de un EditorBoxSortable
   */
  onBoxDropped: PropTypes.func.isRequired,
  /**
   * Alínea la caja verticalmente
   */
  onVerticallyAlignBox: PropTypes.func.isRequired,
  /**
   * Reordena las cajas dentro de su contenedor
   */
  onBoxesInsideSortableReorder: PropTypes.func.isRequired,
  /**
   * Borra un contenedor
   */
  onSortableContainerDeleted: PropTypes.func.isRequired,
  /**
   * Reordena los contenedores
   */
  onSortableContainerReordered: PropTypes.func.isRequired,
  /**
   * Redimensiona un contenedor
   */
  onSortableContainerResized: PropTypes.func.isRequired,
  /**
   *  Callback for selecting contained view
   */
  onContainedViewSelected: PropTypes.func.isRequired,
  /**
   * Hace aparecer/desaparecer el CKEditor
   */
  onTextEditorToggled: PropTypes.func.isRequired,
  /**
   * Whether or not the grid is activated for slides
   */
  grid: PropTypes.bool,
  /**
   * Function for uploading files
   */
  uploadFunction: PropTypes.func,
};
